import { useLang } from "@/i18n";
import { IMG } from "@/data/media";
import { PageHero } from "@/components/PageHero";
import { FadeUp } from "@/components/motion";
import { SupportCta } from "@/components/SupportCta";

const ROW_IMAGES = ["childBed", "twoChildren", "selfie", "staff", "kidsBanner"];
const CORNERS = ["petal-bl", "petal-tr", "petal-br", "petal-tl", "petal-bl"];

export default function Activities() {
  const { t } = useLang();
  const a = t.activities;
  return (
    <>
      <PageHero eyebrow={a.eyebrow} lines={a.titleLines} intro={a.intro} image={IMG.smilingGirls} imageAlt={t.gallery.captions.smilingGirls} corner="tr" accent="var(--coral)" />
      <section className="py-16 sm:py-24 bg-white">
        <div className="wrap space-y-20 sm:space-y-28">
          {a.items.map(([title, text], i) => (
            <div key={title} className="grid gap-10 lg:grid-cols-12 items-center" data-testid={`activity-row-${i}`}>
              <FadeUp className={`lg:col-span-5 ${i % 2 ? "lg:order-2 lg:col-start-8" : ""}`}>
                <div className={`aspect-square overflow-hidden img-zoom ${CORNERS[i]} bg-[var(--green-pale)] max-w-md mx-auto lg:mx-0`}>
                  <img src={IMG[ROW_IMAGES[i]]} alt={t.gallery.captions[ROW_IMAGES[i]]} loading="lazy" className="photo w-full h-full object-cover" />
                </div>
              </FadeUp>
              <FadeUp delay={0.1} className={`lg:col-span-6 ${i % 2 ? "lg:order-1 lg:col-start-1" : "lg:col-start-7"}`}>
                <span className="font-display italic text-6xl text-[var(--green-deep)]">0{i + 1}</span>
                <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl leading-tight">{title}</h2>
                <p className="mt-6 text-lg leading-relaxed text-[var(--ink-soft)]">{text}</p>
                {i === 4 && (
                  <>
                    <div className="mt-6 flex flex-wrap gap-2">
                      {a.structures.map((s) => <span key={s} className="px-4 py-2 rounded-full bg-[var(--green-pale)] text-[var(--green-deep)] text-sm font-semibold">{s}</span>)}
                    </div>
                    <p className="mt-3 text-sm text-[var(--ink-soft)]">{a.structuresNote}</p>
                  </>
                )}
              </FadeUp>
            </div>
          ))}
        </div>
      </section>
      <SupportCta />
    </>
  );
}
